export const apiUrls = {
  drrCcdDeviceApplicationUrl: 'drr-ccd-device-application',
  drrCcdUploadDocumentsUrl: 'gridCompApplication/documents',
  drrCcdCreatePowerPlantOperatorAddress: 'drr-ccd-device-application/operatorAddress',
};
